export const NO_DATA_TEXT = 'No Results';

export const SORT_DIRECTIONS = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
};

export const SORT_TYPES = {
  ALPHABETICAL: 'alphabetical',
  NUMERICAL: 'numerical',
  LENGTH: 'length',
  DATE: 'date',
  TIME: 'time'
};